/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { AxiosError } from 'axios'

/**
 * Extraído de `instancias-api.ts` para ser compartilhado entre o client
 * autenticado (`gatewayApi`) e o client público
 * (`instancia-api-publica.ts`), sem import cruzado entre os dois.
 */
type CorpoMensagemApi = {
  mensagem?: string
  Mensagem?: string
  errors?: string[]
  Errors?: string[]
}

export type ApiErro = AxiosError<CorpoMensagemApi[] | CorpoMensagemApi>

export const isApiError = (err: ApiErro | Error): err is ApiErro => {
  return (err as ApiErro).response !== undefined
}

const mensagemDeItem = (item: unknown): string | undefined => {
  if (!item || typeof item !== 'object') return undefined

  const corpo = item as CorpoMensagemApi
  const valor = corpo.mensagem ?? corpo.Mensagem

  return typeof valor === 'string' && valor.trim().length > 0
    ? valor
    : undefined
}

const extrairMensagensDoCorpo = (data: unknown): string[] => {
  if (data == null) return []

  if (Array.isArray(data)) {
    return data
      .map(mensagemDeItem)
      .filter((mensagem): mensagem is string => !!mensagem)
  }

  // Formato do CustomResponse (base dos controllers): { success: false, errors: string[] }
  const corpo = data as CorpoMensagemApi
  const listaDeErros = corpo.errors ?? corpo.Errors
  if (Array.isArray(listaDeErros) && listaDeErros.length > 0) {
    return listaDeErros.filter(
      (mensagem): mensagem is string =>
        typeof mensagem === 'string' && mensagem.trim().length > 0
    )
  }

  const unica = mensagemDeItem(data)
  return unica ? [unica] : []
}

export const obterMensagensDaApi = (err: ApiErro): Promise<string[]> => {
  if (err.config?.responseType === 'blob') {
    return new Promise(resolve => {
      const fr = new FileReader()

      fr.onloadend = function () {
        try {
          resolve(extrairMensagensDoCorpo(JSON.parse(String(this.result))))
        } catch {
          resolve([])
        }
      }

      fr.readAsText((err.response?.data as unknown) as Blob)
    })
  }

  return Promise.resolve(extrairMensagensDoCorpo(err.response?.data))
}

export const getApiError = (err: ApiErro | Error): Promise<string[]> => {
  if (isApiError(err)) {
    return obterMensagensDaApi(err).then(mensagens => {
      if (mensagens.length > 0) return mensagens
      if (err.message) return [err.message]
      return []
    })
  }

  if (err.message) {
    return Promise.resolve([err.message])
  }

  return Promise.resolve([])
}
